/* eslint-disable */
import { useEffect } from "react";
import { Button, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import DataTable from "../../../components/features/Datatable";
import Filter from "./Filter";
import { setSlugs } from "../../../slices/help";
import { getInboundListing } from "../../../slices/logisticSlice";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { hasAuthority } from "../../../../utils/authorities";
import ChatModule from "../../Chat";
import { addPatientList, addPhaseList } from "../../../slices/chat";
import {capitalizeWords} from "../../../../utils/utils";

const filterConfig = {
  phase_type: {
    label: "Type",
    enum: {
      1: "Trial",
      2: "PMS",
      3: "Commercial",
    },
  },
  apheresis_date: {
    label: "Apheresis Date",
  },
};

const InBound = () => {
  const navigate = useNavigate();
  const LoginData = useSelector((state) => state.loginData);
  const bmr_permissions = LoginData?.bmr_permissions || [];
  const dispatch = useDispatch();
  const { inboundListing } = useSelector(
    (state) => state.bmrLogistic
  );
  const updateFilter = (filter) => {
    fetchUsers(filter);
  };

  const fetchUsers = async (filter) => {
    await dispatch(getInboundListing(filter));
  };

  const columns = [
    {
      id: "subject_code",
      name: "ID",
      selector: (row) =>
        row.subject_code ? row.subject_code : "N/A",
      sortable: true,
    },
    {
      id: "subject_name",
      name: "Subject Name",
      selector: (row) => (row.subject_name ? capitalizeWords(row.subject_name) : "N/A"),
      sortable: true,
    },
    {
      id: "product_phase",
      name: "Product/Phase",
      selector: (row) =>
        row.product_name && row.phase_name
          ? `${capitalizeWords(row.product_name)}/${capitalizeWords(row.phase_name)}`
          : "N/A",
      sortable: true,
    },
    {
      id: "phase_type",
      name: "Type",
      selector: (row) => (row.phase_type ? row.phase_type : "N/A"),
      sortable: true,
    },
    {
      id: "hospital_name",
      name: "Hospital",
      selector: (row) => (row.hospital_name ? row.hospital_name : "N/A"),
      sortable: true,
    },
    {
      id: "scheduled_apheresis_date",
      name: "Apheresis Date",
      selector: (row) =>
        row.scheduled_apheresis_date
          ? moment(row.scheduled_apheresis_date).format("DD/MM/YYYY")
          : "N/A",
      sortable: true,
    },
    {
      id: "shipment_status",
      name: "Status",
      selector: (row) =>
        row.shipment_status ? (
        <p className={`${ row.shipment_status === "Shipped"
              ? "text-[#00B278]"
              : row.shipment_status === "Pending"
              ? "text-[#FF2023]"
              : "text-[#24B9DF]" 
          } font-roboto font-normal text-[14px] leading-[100%] tracking-[0%]`}
        > {row?.shipment_status}
            </p>
        ) : (
          "N/A"
        ),
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <Button
          onClick={() =>
            navigate(`/bmr/logistics-management/in-bound/view/${row?.qr_code_generated_id}/${row?.feasibility_id}`,{
              state: [
            { name: "LSM Inbound", path: location.pathname },
            {
              name: "Details",
              path: `/bmr/logistics-management/in-bound/view/${row?.qr_code_generated_id}/${row?.feasibility_id}`,
            },
            ]
            })
          }
          key={row?.subject_id}
          size="small"
          className="!w-[100px]"
        >
          View Details
        </Button>
      ),
    },
  ];

  useEffect(() => {
    if (hasAuthority(["in-bound-marked-shipped"], bmr_permissions)) {
      dispatch(setSlugs(["lsm-shipped"]));
    }
    return () => {
      dispatch(setSlugs([""]));
    };
  }, []);



  useEffect(() => {
      const phaseList = inboundListing?.items?.map(op => { return { value: op?.phase_id, label: `${op?.phase_name} (${op?.product_name})`, patient_id: op?.subject_id } })
      const patientList = inboundListing?.items?.map(op => { return { value: op?.subject_id, label: `${op?.subject_name}`, phase_id: op?.phase_id } })
      dispatch(addPatientList(patientList))
      dispatch(addPhaseList(phaseList))
  }, [inboundListing])


  return (
    <Grid
      container
      className="mt-4 ml-0 mr-3 mainDiv"
      rowSpacing={4.5}
      columnSpacing={2.75}
    >
      <Grid item xs={12} sx={{ mt: -2.25 }}>
        {hasAuthority(['in-bound-listing'], bmr_permissions) &&
          <div>
            <DataTable
              columns={columns}
              data={inboundListing}
              title="LSM Inbound"
              FilterComponent={Filter}
              onServerSideChange={updateFilter}
              remote={true}
              filterConfig={filterConfig}
            />
            <ChatModule />
          </div>
        }
      </Grid>
    </Grid>
  );
};

export default InBound;
